import axios, { AxiosResponse } from 'axios';
import { parseJwt } from '../../../misc/Helpers';
import { Environment } from '../../../environment';
import { IFormPartnerData } from '../../../types/types';

// Criando a instância do Axios
const instance = axios.create({
    baseURL: Environment.URL_BASE,
});

// Interceptor de requisição para verificar a expiração do token
instance.interceptors.request.use(
    function (config) {
        const authHeader = config.headers?.Authorization;
        if (typeof authHeader === 'string' && authHeader.startsWith('Bearer ')) {
            const token = authHeader.split(' ')[1];
            const data = parseJwt(token);
            if (Date.now() > data.exp * 1000) {
                window.location.href = '/login';
                return Promise.reject('Token expirado');
            }
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

// Função para criar a autenticação Bearer
function bearerAuth(user: { accessToken: string }): string {
    return `Bearer ${user.accessToken}`;
}

// Funções do serviço
export const LeadsServiceAPI = {
    getMyLeads,
    getLeads,
    addNote
};

// Função para obter os leads
function getLeads(user: { accessToken: string }) {
    return instance.get('/leads/all', {
        headers: { 'Authorization': bearerAuth(user) },
    });
}

// Função para obter os leads
function getMyLeads(user: { accessToken: string; data: { idUser: number } }) {
    return instance.get('/leads/my-leads/' + user.data.idUser, {
        headers: { 'Authorization': bearerAuth(user) },
    });
}



// Função para salvar dados (exemplo)
function addNote(user: { accessToken: string; data: { idUser: number } }, leadId: string, note: string) {
    return instance.post('/leads/addNote',
        {
            id: leadId,  // Usando o 'leadId' como 'id' para o backend
            note: note,
            userId: user.data.idUser,
        },
        {
            headers: { 'Authorization': bearerAuth(user) },
        }
    )
        .then((response: AxiosResponse) => response.data)
        .catch((error) => {
            console.error("Erro ao salvar dados", error);
            throw error;
        });
}

function create(user: { accessToken: string }, dadosValidados: IFormPartnerData) {
    console.log(dadosValidados);
    return instance.post('/customer/create', dadosValidados, {
        headers: {
            'Content-type': 'application/json',
            'Authorization': bearerAuth(user),
        },
    });
}
